import { useMutation, useQueryClient } from '@tanstack/react-query';

import { checklistApi } from '@features/Checklist/api';

export const useUpdateChecklistData = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: checklistApi.updateChecklistDataQuery,
        onSuccess: (response, variables) => {
            queryClient.setQueryData(
                checklistApi.getChecklistDataQuery({ positionGuid: variables.positionGuid }).queryKey,
                response
            );
        },
    });
};
